document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".image-grid-text");
  const BREAKPOINT = 992;

  sections.forEach((section) => {
    const cardSwiper = section.querySelector(".icon-cards-swiper");
    if (!cardSwiper) return;

    const prevEl = section.querySelector(".swiper-controls .prev");
    const nextEl = section.querySelector(".swiper-controls .next");

    let swiperInstance = null;

    function initSwiper() {
      if (swiperInstance) return;

      swiperInstance = new Swiper(cardSwiper, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 800,
        allowTouchMove: true,
        simulateTouch: true,
        freeMode: false,
        followFinger: true,
        touchRatio: 1,
        threshold: 10,
        shortSwipes: true,
        longSwipes: true,
        longSwipesRatio: 0.3,
        longSwipesMs: 300,
        resistance: true,
        resistanceRatio: 0.85,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
      });
    }

    function destroySwiper() {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    function handleResize() {
      if (window.innerWidth < BREAKPOINT) {
        initSwiper();
      } else {
        destroySwiper();
      }
    }

    handleResize();
    window.addEventListener("resize", handleResize);
  });
});
